<template>
  <ul class="course-categories">
    <b-collapse animation="" :open="true" aria-id="right-categories-list">
      <li @click="open" class="list_header categories active" slot="trigger" aria-controls="right-categories-list">
        <span class="left"> <i class="icon-button-arrow"></i>Категории курсов </span>
      </li>
      <li v-for="(category, i) in CategoriesList" :key="i" class="list_item category">
        <span class="left">
          {{ category.name }}
        </span>
        <span v-if="!category.deleted_at" class="right">
          <i @click="deleteCategory(category)" class="mdi mdi-close"></i>
        </span>
        <span v-else class="right">
          <i @click="$emit('restore-category', category.id)" class="mdi mdi-plus"></i>
        </span>
      </li>
    </b-collapse>
  </ul>
</template>

<script>
export default {
  props: {
    CategoriesList: {
      default: () => [],
      type: Array
    }
  },
  methods: {
    deleteCategory(category) {
      this.$emit('delete-category', category.id)
    },
    open(e) {
      if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    }
  }
}
</script>
